<template>
  <div>
    <div class="row">
        <div class="col-9 col-md-6">
          <p style="background-color: #ccffff; border-width: 1px !important;" class="text-start px-md-4 border border-success">
            <font size="6">良い声判定マシン</font>
          </p>
        </div>
        <div class="col-1 col-md-1">
          <div class="twitter_share">
            <a href="https://twitter.com/intent/tweet?url=https://s-shinomoto.com/voice/&text=良い声判定マシン" target="_blank"
              class="btn-social-icon btn_sns btn-twitter">
              <span class="twitter-icon">
                <font-awesome-icon icon="fa-brands fa-twitter" style="color: #ffffff;" />
              </span>
            </a>
          </div>
        </div>
        <div class="col-1 col-md-1">
          <div class="facebook_share">
            <a href="http://www.facebook.com/share.php?u=https://s-shinomoto.com/voice/" target="_blank"
              class="btn-social-icon btn_sns btn-facebook ">
              <span class="facebook-icon">
                <font-awesome-icon icon="fa-brands fa-facebook-f" style="color: #ffffff;" />
              </span>
            </a>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Head',
}
</script>

<style>

.btn_sns {
  display: block;
  color: white;
  border-radius: 20px;
  text-decoration: none;
  padding: 6px 12px;
  font-size: 16px;
  width: 50%;
  margin-top: 10px;
  text-align: center;
}

/* ボタン色を設定 */
.btn-facebook {
  background-color: #3755a0;
  margin-left: 10px;
  margin-right: auto;
}

.btn-twitter {
  background-color: #2598ef;
  margin-left: auto;
  margin-right: auto;
}

</style>